module.exports = __webpack_public_path__ + "static/media/use_graph01_ch02.7ec377e1.jpg";